// extracted by mini-css-extract-plugin
export default {"logo":"Header_logo__bLBIg","icon":"Header_icon__MrLJE"};